.wrapper {
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  height: 4rem;
  padding: 0 2rem;
  background-color: var(--white);
}

.inputWrapper {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: var(--gray-light);
  border-radius: 10px;
  padding-left: 1rem;
  width: 216px;
}

.inputIcon {
  color: var(--text-dark);
  z-index: 1;
}

.loader {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  min-height: 4rem;
  max-height: 4rem;
}

.tableWrapper {
  background-color: var(--white);
  padding: 0 0 2rem 0;
  border-radius: 0 0 8px 8px;
  font-family: 'Aeroport';
}

.tableHeader {
  display: flex;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 36px 3.5rem 72px 3.5rem;
}

.table {
  display: flex;
  flex-direction: column;
  background-color: var(--white);
}

.row {
  border-bottom: 1px solid var(--gray);
  margin-bottom: 0 !important;
}

.rowLevel {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: 1.9rem 3.5rem 0.9rem 3.5rem;
}

.rowLeft {
  display: flex;
  align-items: center;
  flex: 1.3;
}

.rowRight {
  display: flex;
  align-items: center;
  flex: 1;
}

.rowItem {
  display: flex;
  align-items: center;
  flex: 1;
}

.rowItemCollapse {
  flex: 0 0;
  min-width: 44px;
}

.rowMenu {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
}

.labelRow {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
}

@media screen and (max-width: 768px) {
  .rowLevel,
  .rowLeft,
  .rowRight {
    flex-direction: column;
    align-items: flex-start;
  }
}

.textMuted {
  color: var(--gray-darker);
  font-size: 15px;
}

.rowItemExpand {
  flex-grow: 2;
}

.label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 4px;
  font-weight: 500;
  gap: 4px;
}

.tags {
  display: flex;
}

.collapse {
  transition: height 300ms ease-in-out;
}

.collapseContent {
  display: flex;
  position: relative;
  flex-direction: row;
  flex: 1;
}

.modalBodyText {
  font-size: 16px;
}

.dischargedButton {
  width: 216px;
  background-color: #f5f7fc;
  border-radius: 10px;
  text-align: center;
  height: 51px;
  line-height: 51px;
}

.dischargedButton span {
  font-size: 18px;
  color: #c1c5cf;
}

.dischargedButton:hover {
  cursor: disabled;
}

.envelopeIconDiv {
  display: inline-flex;
  align-self: flex-start;
  padding: 14px 12px 0 0;
}

.envelopeIcon {
  margin: 8px;
}

.envelopeIcon:hover {
  cursor: pointer;
}

.inputDetails {
  width: 300px;
  margin-right: 2rem;
}

.progressLabelContainer {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
}

.progressLabelBullet {
  width: 16px;
  height: 16px;
  border-radius: 100px;
  background-color: var(--gray-lighter);
}

.progressLabelText {
  font-style: 18px;
  font-weight: 500;
  line-height: 24px;
  color: var(--black);
}
